// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_5d4","cls2":"Header-cls2_tIk Header-cls1_5d4"};